<!-- 考试 -->
<template>
    <div>
      <div class="course_ExamList">
        <el-row class="content_block">
          <el-row class="mb10">
            <el-button type="primary" icon="el-icon-plus" @click="addExamListInfo">新增</el-button>
            <el-button type="success" icon="el-icon-printer" @click="exportInfo">导出</el-button>
          </el-row>
          <el-row class="mb10">
            <label>考试汇总：【合计考试次数：{{analysisInfo.totalSettingCount || 0}}；
            合计考试班级：{{analysisInfo.totalSchoolClassCount || 0}}；合计平均答对数量：{{analysisInfo.avgCorrectCount || 0}}；
            合计平均答错数量：{{analysisInfo.avgWrongCount || 0}}；合计平均正确率：{{analysisInfo.avgQuestionLogSummarySuccessRate || 0}} %；合计得分：{{analysisInfo.avgQuestionSettingTotalScore || 0}}】</label>
          </el-row>
          <el-row>
            <el-table
              :data="tableData"
              border
              style="width: 100%">
              <el-table-column type="index" header-align="center" align="center" width="100" label="序号"></el-table-column>
              <el-table-column prop="teacherOpenCourseQuestionSettingName" header-align="center" align="center" label="考试名称"> </el-table-column>
              <el-table-column prop="teacherOpenCourseQuestionSettingSchoolClassNames" header-align="center" align="center" label="考试班级"> </el-table-column>
              <el-table-column prop="time" header-align="center" align="center" label="考试时间">
                <template slot-scope="scope">
                    {{scope.row.teacherOpenCourseQuestionStartTime}} ~ {{scope.row.teacherOpenCourseQuestionEndTime}}
                </template>
              </el-table-column>
              <el-table-column prop="avgSuccessCount" header-align="center" align="center" label="平均答对数量"> </el-table-column>
              <el-table-column prop="avgErrorCount" header-align="center" align="center" label="平均答错数量"> </el-table-column>
              <el-table-column prop="avgSuccessRate" header-align="center" align="center" label="平均正确率">
                 <template slot-scope="scope">
                   {{scope.row.avgSuccessRate || 0}} %
                 </template>
              </el-table-column>
              <el-table-column prop="avgScore" header-align="center" align="center" label="平均得分"  width="100"> </el-table-column>
              <el-table-column prop="messageAcceptState" header-align="center" align="center" label="状态" width="100">
                <template slot-scope="scope">
                  <span :class="scope.row.teacherOpenCourseQuestionSettingPushStatus == 'PUSH'?'':'red'">
                    {{scope.row.teacherOpenCourseQuestionSettingPushStatus == 'PUSH'?"发布":"未发布"}}
                  </span>
                </template>
              </el-table-column>
              <el-table-column prop="messageAcceptState" header-align="center" align="center" label="操作" width="360">
                <template slot-scope="scope">
                  <template v-if="scope.row.teacherOpenCourseQuestionSettingPushStatus == 'UN_PUSH'">
                    <el-link type="primary" :underline="false" style="margin-right: 10px;" @click="releaseInfo(scope.row,'PUSH')">发布</el-link>
                  </template>
                  <el-link type="primary" :underline="false" style="margin-right: 10px;" @click="editExamListInfo(scope.row)">编辑</el-link>
                  <el-link type="primary" :underline="false" style="margin-right: 10px;" @click="delInfo(scope.row)">删除</el-link>
                  <el-link type="primary" :underline="false" style="margin-right: 10px;" @click="ExamListScore(scope.row)">考试成绩</el-link>
                  <el-link type="primary" :underline="false" style="margin-right: 10px;" @click="ExamListPreview(scope.row)">试卷预览</el-link>
                  <el-link type="primary" :underline="false" @click="ExamListDetails(scope.row)">考试详情</el-link>
                </template>
              </el-table-column>
            </el-table>
            <div class="block" style="text-align: right;bottom: 0;width: 96%;margin: 20px;">
              <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page.sync="page"
                :page-sizes="[8, 20, 50, 100]"
                :page-size="limit"
                background
                :hide-on-single-page="false"
                layout="sizes, prev, pager, next,jumper"
                :total="total">
              </el-pagination>
            </div>
          </el-row>
        </el-row>

        <!-- 新增考试 -->
        <el-dialog
          title="新增考试"
          :visible.sync="homewordk_add_dialog"
          class="dialog_"
          width="900px">
          <ExamListAdd ref="homeworkAdd"
          :classList="classList"
          v-if="homewordk_add_dialog"
          :homeInfo="homeInfo"
          :courseId="courseId"></ExamListAdd>
          <span slot="footer" class="dialog-footer">
            <el-button @click="homewordk_add_dialog = false">取 消</el-button>
            <el-button type="primary" @click="homewordkAdd">确 定</el-button>
          </span>
        </el-dialog>

        <!-- 试卷预览对话框（只读，不能作答） -->
        <el-dialog
          :title="'试卷预览 - ' + preview_name"
          :visible.sync="preview_dialog"
          class="dialog_"
          width="900px">
          <div class="preview_paper" v-loading="preview_loading">
            <template v-for="(item,index) in preview_question_list">
              <el-row :key="'type'+index" class="preview_type_title">
                {{$retQuestionType(item.questionType)}}（共{{item.list.length}}题，合计{{item.totalScore}}分）
              </el-row>
              <el-row v-for="(it,ind) in item.list" :key="it.resourcesQuestionSnapshotId" class="preview_question">
                <!-- 题号 + 题干 + 分值 -->
                <el-row class="preview_stem">
                  <span>{{item.startIndex + ind + 1}}、</span>
                  <span class="preview_stem_html" v-html="$getReplace(it.questionStem)"></span>
                  <span style="color: #5464FF;">（{{it.questionScore}} 分）</span>
                </el-row>
                <!-- 单选/多选：只读展示选项，不做答 -->
                <el-row class="preview_option" v-if="it.questionType == 1 || it.questionType == 2">
                  <el-row v-if="!$isEmpty(it.questionOptionA)"><span class="preview_option_label">A、</span><span v-html="$imgHtml(it.questionOptionA)"></span></el-row>
                  <el-row v-if="!$isEmpty(it.questionOptionB)"><span class="preview_option_label">B、</span><span v-html="$imgHtml(it.questionOptionB)"></span></el-row>
                  <el-row v-if="!$isEmpty(it.questionOptionC)"><span class="preview_option_label">C、</span><span v-html="$imgHtml(it.questionOptionC)"></span></el-row>
                  <el-row v-if="!$isEmpty(it.questionOptionD)"><span class="preview_option_label">D、</span><span v-html="$imgHtml(it.questionOptionD)"></span></el-row>
                  <el-row v-if="!$isEmpty(it.questionOptionE)"><span class="preview_option_label">E、</span><span v-html="$imgHtml(it.questionOptionE)"></span></el-row>
                </el-row>
                <!-- 判断题 -->
                <el-row class="preview_option" v-if="it.questionType == 3">
                  <el-row>对</el-row>
                  <el-row>错</el-row>
                </el-row>
                <!-- 填空题 -->
                <el-row class="preview_option" v-if="it.questionType == 4">
                  <el-row>（{{it.questionOptionA}}空）</el-row>
                </el-row>
                <!-- 分析题 -->
                <el-row class="preview_option" v-if="it.questionType == 5">
                  <el-row v-if="!$isEmpty(it.questionOptionB)" v-html="$imgHtml(it.questionOptionB)"></el-row>
                  <el-row>（{{it.questionOptionA}}空）</el-row>
                </el-row>
              </el-row>
            </template>
            <el-row v-if="preview_question_list.length <= 0 && !preview_loading" class="tc" style="padding: 40px 0;">
              暂无题目信息！
            </el-row>
          </div>
          <span slot="footer" class="dialog-footer">
            <el-button @click="preview_dialog = false">关 闭</el-button>
          </span>
        </el-dialog>
      </div>
    </div>
</template>
<script>

import ExamListAdd from "./ExamListAdd";	//页面头部
import {getClassInfo} from "@/common/getInfo";	//加载数据
export default {
  name: 'ExamList',
  components: {
    ExamListAdd
  },
  props: {
    courseId: { //课程ID
      type: String,
      required:true
    }
  },
  data() {
    return {
      tableData:[],
      noticeList:[], //当前页数据

      total: 0,
      limit:8,
      page:1,
      homewordk_add_dialog:false, //添加考试show
      homewordk_dialog:false, //提交考试show
      homeInfo:{}, //作业信息  编辑时使用
      classList:[],
      analysisInfo:{},
      preview_dialog:false, //试卷预览show
      preview_loading:false, //试卷预览loading
      preview_name:"", //预览的试卷名称
      preview_question_list:[] //试卷题目（按题型分组）
    }
  },
  created() {
    this.getInfo();
    this.analysis();
    getClassInfo({teacherOpenCourseId:this.courseId}).then(ret =>{ //根据课程ID获取班级信息
      if(ret.code == 0){
        this.classList = ret.data;
      }
    });
  },
  mounted() {
    this.getInfo();
  },
  methods: {
    handleClick(){

    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.limit = val;
      this.getInfo();
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.page = val;
      this.getInfo();
    },
    analysis(){
      this.$post("/api/teacherOpenCourseQuestionSetting/analysisTotal.do",{teacherOpenCourseId:this.courseId,questionSettingType:"EXAM"}).then((ret) =>{
        if(ret.code == 0){
          this.analysisInfo = ret.data;
        }else{
          this.$message({message: ret.msg,type: 'error'});
        }
      });
    },
    getInfo(){ //获取列表
      let param = {
        limit:this.limit,
        page:this.page,
        teacherOpenCourseId:this.courseId,
        teacherOpenCourseQuestionSettingType:"EXAM"
      }
      this.$post("/api/teacherOpenCourseQuestionSetting/getPageList.do",param).then((ret) =>{
        if(ret.code == 0){
          this.total = Number(ret.count);
          this.tableData = ret.data;
        }else{
          this.$message({message: ret.msg,type: 'error'});
        }
      });
    },
    startExamList(item,type){ //开始考试 type:1考试 2:详情
      this.$router.push({name:'Exercises',query:{type:type,item:item}});
    },
    addExamListInfo(){ //新增考试对话框
      this.homeInfo = {};
      this.homewordk_add_dialog = true;
    },
    editExamListInfo(item){
      this.homeInfo = item;
      this.homewordk_add_dialog = true;
    },
    exportInfo(){ //导出信息
      this.$confirm('是否确定导出信息?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$downLoadFile('/api/teacherOpenCourseQuestionSetting/exportPageList.do?teacherOpenCourseQuestionSettingType=EXAM&teacherOpenCourseId='+this.courseId, `考试信息-导出${new Date().toLocaleString()}.xlsx`);
        // this.$message({type: 'success',message: '导出成功！'});
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        });
      });
    },
    releaseInfo(item,pushStatus){ //发布信息
      let param = {
        ids:item.teacherOpenCourseQuestionSettingId,
        pushStatus:pushStatus // 发布 PUSH 未发布UN_PUSH
      }
      this.$post("/api/teacherOpenCourseQuestionSetting/editPushStatus.do",param).then((ret) =>{
        if(ret.code == 0){
          this.getInfo();
          this.$message({type: 'success',message: '发布成功！'});
        }else{
          this.$message({message: ret.msg,type: 'error'});
        }
      });
    },
    ExamListScore(item){ //考试成绩
      this.$router.push({name:'ExamListScore',query:{id:item.teacherOpenCourseQuestionSettingId,courseId:this.courseId}});
    },
    ExamListDetails(item){ //考试详情
      this.$router.push({name:'TExamListDetails',query:{id:item.teacherOpenCourseQuestionSettingId,courseId:this.courseId}});
    },
    ExamListPreview(item){ //试卷预览（只读查看试卷题目，不能作答）
      this.preview_name = item.teacherOpenCourseQuestionSettingName;
      this.preview_question_list = [];
      this.preview_dialog = true;
      this.preview_loading = true;
      //复用考试作答页（Exercises.vue）的取题接口，按考试ID取整卷题目快照
      this.$get("/api/resourcesQuestionSnapshot/getList.do",{
        teacherOpenCourseQuestionSettingId:item.teacherOpenCourseQuestionSettingId
      }).then((ret) =>{
        this.preview_loading = false;
        if(ret.code == 0){
          let list = ret.data || [];
          let groupMap = {}; //按题型分组：1单选 2多选 3判断 4填空 5分析
          list.forEach((it) => {
            let key = "questionType" + it.questionType;
            if(!groupMap[key]){
              groupMap[key] = {questionType:it.questionType,list:[],totalScore:0};
            }
            groupMap[key].list.push(it);
            groupMap[key].totalScore += Number(it.questionScore || 0);
          });
          let startIndex = 0; //跨题型的连续题号
          this.preview_question_list = Object.keys(groupMap).sort().map((key) => {
            let group = groupMap[key];
            group.startIndex = startIndex;
            startIndex += group.list.length;
            return group;
          });
        }else{
          this.$message({message: ret.msg,type: 'error'});
        }
      }).catch(() => {
        this.preview_loading = false;
      });
    },
    delInfo(item){
      this.$confirm('是否确定删除信息?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$post("/jlw/teacherOpenCourseQuestionSetting/delete.json",{ids:item.teacherOpenCourseQuestionSettingId}).then((ret) =>{
          if(ret.code == 0){
            this.getInfo();
            this.$message({type: 'success',message: '删除成功！'});
          }else{
            this.$message({message: ret.msg,type: 'error'});
          }
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        });
      });
    },
    homewordkAdd(){ //保存新增题库信息
      let addForm = this.$refs.homeworkAdd.form; //获取新增题库数据
      let time = this.$refs.homeworkAdd.time; //获取新增题库数据
      let classIds = this.$refs.homeworkAdd.classIds; //获取新增题库数据
      if(this.$isEmpty(addForm.teacherOpenCourseQuestionSettingName)){
        this.$message({message: '请输入作业名称！',type: 'warning'});
        return;
      }
      if(this.$isEmpty(classIds)){
        this.$message({message: '请选择作业班级！',type: 'warning'});
        return;
      }else{
        addForm.teacherOpenCourseQuestionSettingSchoolClassIds = classIds.join(",");
      }
      if(time.length <= 0){
        this.$message({message: '请选择作业时间！',type: 'warning'});
        return;
      }else{
        addForm.teacherOpenCourseQuestionStartTime = time[0];
        addForm.teacherOpenCourseQuestionEndTime = time[1];
      }
      if(this.$isEmpty(addForm.teacherOpenCourseQuestionSettingDoCount)){
        this.$message({message: '请输入作业次数！',type: 'warning'});
        return;
      }
      let questionSettingOptions = this.$refs.homeworkAdd.questionSettingOptions; //获取新增题库数据
      if(this.$isEmpty(questionSettingOptions)){
        this.$message({message: '请设置题目！',type: 'warning'});
        return;
      }
      // addForm.questionSettingOptions = JSON.stringify(questionSettingOptions);
      addForm.questionSettingOptions = questionSettingOptions;
      addForm.teacherOpenCourseQuestionSettingType = "EXAM"; //考试类型
      addForm.teacherOpenCourseId = this.courseId;
      this.$postJSON("/api/teacherOpenCourseQuestionSetting/addQuestionByType.do",addForm).then((ret) =>{
        if(ret.code == 0){
          this.getInfo();
          this.$message({type: 'success',message: '提交成功！'});
          this.homewordk_add_dialog = false;
        }else{
          this.$message({message: ret.msg,type: 'error'});
        }
      });
    }
  }
};
</script>
<style  lang="less">
  .course_ExamList{
    padding: 20px;
    border: 1px solid #DEDEDE;
    .content_block{
      background-color: #ffffff;
      .el-tabs__nav-wrap::after{
        background-color:white;
      }
      .user_discuss_img{
        width: 60px;
        height: 60px;
        border-radius: 50%;
      }
    }
    .tl_list{
      border-bottom: 1px solid #DEDEDE;padding: 20px 20px 20px 0;
    }
    .tl_list:last-child{
      border-bottom:none;
    }
    .el-form-item__label{
      width: 100px !important;
    }
    .el-form-item__content{
      margin-left: 100px !important;
    }
    .el-form-item{
      margin-bottom: 10px !important;
    }
    /* 试卷预览 */
    .preview_paper{
      max-height: 60vh;
      overflow-y: auto;
      padding: 0 10px;
      font-size: 14px;
      .preview_type_title{
        background-color: #EFF2F7;
        padding: 5px 10px;
        line-height: 30px;
        font-weight: bold;
        margin-top: 10px;
      }
      .preview_question{
        border-bottom: 1px solid #DEDEDE;
        padding: 10px 0;
        .preview_stem{
          line-height: 22px;
          margin-bottom: 5px;
          .preview_stem_html{
            display: inline;
            p{
              display: inline;
              margin: 0;
            }
          }
        }
        .preview_option{
          line-height: 24px;
          padding-left: 20px;
          .preview_option_label{
            float: left;
          }
        }
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/pages/Teacher/components/ExamList.vue